import React, { useEffect, useState } from "react";
import Skeleton from "react-loading-skeleton";
import { FooterReport, Gap, GridInline, LabelTitle, Line } from "../../../../components/Global";
import "react-loading-skeleton/dist/skeleton.css";
import { CONFIG_DEV } from "../../../../config/ConfigDev";
import accountManagement from "../../../../apis/accountManagement";
import LoaderModal from "../../../../components/modal/LoaderModal";
import PageTwo from "./PageTwo";
import LoadingPage from "./LoadingPage";

const PageOne = ({
    idJadwalCbt,
    idKelas,
    kodeTahunAjaran,
    kuotaPariwisata,
    kuotaBisnisDanManajemen,
    kuotaSeniDanEkonomiKreatif,
    kuotaAgribisnisDanAgriteknologi,
    kuotaKemaritiman,
    kuotaKesehatanDanPekerjaanSosial,
    kuotaTeknologiInformasi,
    kuotaTeknologiManufakturDanRekayasa,
    kuotaTeknologiKonstruksiDanProperti,
    kuotaEnergiDanPertambangan,
}) => {
    const [fetching, setFetching] = useState(false);
    const [detailSekolah, SetDetailSekolah] = useState([]);
    const [listFinalJurusan, SetListFinalJurusan] = useState([]);
    const [openPage, setOpenPage] = useState(false);
    const [jumlahSiswa, setJumlahSiswa] = useState(0);
    const [jumlahSiswaSesuaiMinat, setJumlahSiswaSesuaiMinat] = useState(0);
    const [persenSiswaSesuaiMinat, setPersenSiswaSesuaiMinat] = useState(0);
    const [jumlahSiswaPindahBidang, setJumlahSiswaPindahBidang] = useState(0);
    const [persenSiswaPindahBidang, setPersenSiswaPindahBidang] = useState(0);

    const today = new Date();
    const suflix = today.getHours() >= 12 ? " PM" : " AM";
    const dateTime = today.getDate() + "/" + (today.getMonth() + 1) + "/" + today.getFullYear() + ", " + today.getHours() + "." + today.getMinutes() + suflix;

    useEffect(() => {
        const getDatas = async () => {
            setFetching(true);
            const response = await accountManagement
                .post(CONFIG_DEV.REPORT_PEMETAAN2_PAGE_ONE, {
                    kodeTipeCbt: "PEMETAAN2",
                    idJadwalCbt: idJadwalCbt,
                    idKelas: idKelas,
                    kodeTahunAjaran: kodeTahunAjaran,
                    kuotaPariwisata: kuotaPariwisata,
                    kuotaBisnisDanManajemen: kuotaBisnisDanManajemen,
                    kuotaSeniDanEkonomiKreatif: kuotaSeniDanEkonomiKreatif,
                    kuotaAgribisnisDanAgriteknologi: kuotaAgribisnisDanAgriteknologi,
                    kuotaKemaritiman: kuotaKemaritiman,
                    kuotaKesehatanDanPekerjaanSosial: kuotaKesehatanDanPekerjaanSosial,
                    kuotaTeknologiInformasi: kuotaTeknologiInformasi,
                    kuotaTeknologiManufakturDanRekayasa: kuotaTeknologiManufakturDanRekayasa,
                    kuotaTeknologiKonstruksiDanProperti: kuotaTeknologiKonstruksiDanProperti,
                    kuotaEnergiDanPertambangan: kuotaEnergiDanPertambangan,
                })
                .catch(function (error) {
                    console.error("Error HW_REPORT_BY_KP", error);
                });

            if (response) {
                if (response.data.data) {
                    const responseAPI = response.data.data;
                    console.log("====================================");
                    console.log("Response Page One ", responseAPI);
                    console.log("====================================");

                    SetDetailSekolah(responseAPI.detailSekolah);
                    SetListFinalJurusan(responseAPI.listFinalJurusanRekomendasiPlacement);

                    setJumlahSiswaSesuaiMinat(responseAPI.summary.sesuaiMinat);
                    setJumlahSiswaPindahBidang(responseAPI.summary.pindahBidang);
                    setPersenSiswaSesuaiMinat(Math.round((responseAPI.summary.sesuaiMinat / responseAPI.summary.totalSiswa) * 100));
                    setPersenSiswaPindahBidang(Math.round((responseAPI.summary.pindahBidang / responseAPI.summary.totalSiswa) * 100));

                    (function () {
                        var script = document.createElement("script");
                        script.type = "text/javascript";
                        script.src = "/assets/js/easypiechart-data.js";
                        document.getElementsByTagName("head")[0].appendChild(script);
                    })();
                }
                setFetching(false);
                setOpenPage(true);
            }
        };
        getDatas();
    }, []);

    require("../Pemetaan.css");
    return (
        <>
            <LoaderModal isFetching={fetching} />
            <div className="report-page">
                <div className="header-first-page">
                    <div className="text-header">
                        <div className="title-header">SCHOOL ASSESSMENT REPORT</div>
                        <div className="sub-title-header">
                            <b>Asesmen Diagnostik</b>
                        </div>
                    </div>
                    <div className="img-header">
                        <img src="/assets/image/pemetaan.png" width={"20%"} />
                    </div>
                </div>
                <Gap height={20} />
                <div style={{ width: "95%", paddingLeft: "5%" }}>
                    <Line color={"#1D3557"} />
                </div>
                <Gap height={20} />
                <div className="section-one">
                    <div className="biodata-school">
                        {/* Nama Sekolah */}
                        <GridInline width={"50%"} borderRight={"1px solid #E9ECEF"}>
                            <GridInline width={"7%"} marginRight={5}>
                                <img src="/assets/image/school.png" width={"100%"} style={{ marginBottom: -15 }} />
                            </GridInline>
                            <GridInline width={"75%"}>
                                <LabelTitle label={"Nama Sekolah"} size={20} bolder={500} color={"#495057"} />
                            </GridInline>
                            <div style={{ marginLeft: 35 }}>
                                <LabelTitle label={detailSekolah.namaSekolah} size={19} bolder={500} color={"#6C757D"} />
                                {/* <Skeleton /> */}
                            </div>
                        </GridInline>
                        {/* Jumlah Peserta */}
                        <GridInline width={"25%"} paddingLeft={20}>
                            <GridInline width={"14%"} marginRight={5}>
                                <img src="/assets/image/jumlah-peserta.png" width={"100%"} style={{ marginBottom: -15 }} />
                            </GridInline>
                            <GridInline>
                                <LabelTitle label={"Jumlah Siswa"} size={20} bolder={500} color={"#495057"} />
                            </GridInline>
                            <div style={{ marginLeft: 35 }}>
                                <LabelTitle label={detailSekolah.totalSiswa + " Siswa"} size={19} bolder={500} color={"#6C757D"} />
                            </div>
                        </GridInline>
                        {/* Tanggal Pelaksanaan */}
                        <GridInline width={"25%"}>
                            <GridInline width={"14%"} marginRight={5}>
                                <img src="/assets/image/tgl.png" width={"100%"} style={{ marginBottom: -15 }} />
                            </GridInline>
                            <GridInline>
                                <LabelTitle label={"Tanggal Pelaksanaan"} size={20} bolder={500} color={"#495057"} />
                            </GridInline>
                            <div style={{ marginLeft: 35 }}>
                                <LabelTitle label={detailSekolah.tanggalPelaksanaan} size={19} bolder={500} color={"#6C757D"} />
                            </div>
                        </GridInline>
                    </div>
                    <Gap height={20} />
                    <div style={{ width: "95%", paddingLeft: "5%" }}>
                        <Line color={"#E9ECEF"} />
                    </div>
                    <Gap height={20} />
                    <div className="result">
                        <div className="result-pageone">
                            <LabelTitle label={"Summary Asesmen Diagnostik Kognitif"} size={20} bolder={800} color={"#fff"} />
                        </div>
                        <Gap height={20} />
                        <div className="head-table-result">
                            <GridInline width={"100%"} padding={15} marginLeft={15}>
                                <GridInline width={"48%"} marginLeft={15} paddingTop={10}>
                                    <LabelTitle label={"Bidang Keahlian"} size={20} bolder={800} color={"#000"} />
                                </GridInline>
                                <GridInline width={"25%"} textAlign={"center"}>
                                    <LabelTitle label={"Kompetensi"} size={20} bolder={800} color={"#000"} />
                                </GridInline>
                                <GridInline width={"25%"} textAlign={"center"}>
                                    <LabelTitle label={"Placement"} size={20} bolder={800} color={"#000"} />
                                </GridInline>
                            </GridInline>
                        </div>
                        <div className="table-result">
                            {listFinalJurusan.map((hasilPemetaan, i) => {
                                return (
                                    <div key={i}>
                                        <GridInline width={"100%"} padding={15} marginLeft={15}>
                                            <GridInline width={"48%"} marginLeft={15} paddingTop={10}>
                                                {hasilPemetaan.namaJurusan}
                                            </GridInline>
                                            <GridInline width={"25%"} textAlign={"center"}>
                                                {hasilPemetaan.totalRekomendasi} Siswa
                                            </GridInline>
                                            <GridInline width={"25%"} textAlign={"center"}>
                                                {hasilPemetaan.totalPlacement} Siswa
                                            </GridInline>
                                        </GridInline>
                                    </div>
                                );
                            })}
                        </div>
                    </div>
                    <Gap height={20} />
                    <div className="result">
                        <div className="result-pageone">
                            <LabelTitle label={"Kesesuaian Minat dengan Kompetensi"} size={18} bolder={700} color={"#fff"} />
                        </div>
                        <div className="table-result">
                            <div className="container">
                                <div className="row">
                                    <div className="col-lg-6 col-md-6 col-sm-6 col-xs-6 text-center">
                                        <Gap height={20} />
                                        <h4>Sesuai Minat</h4>
                                        <div className="panel panel-default chart_percentase_potensi_siswa">
                                            <div className="panel-body easypiechart-panel">
                                                <div className="easypiechart chart" id="easypiechart-blue" data-percent={persenSiswaSesuaiMinat}>
                                                    <div className="label_persentase_potensi_chart">
                                                        <span className="persentase_potensi">{persenSiswaSesuaiMinat}%</span>
                                                        <br />
                                                        <span className="jumlah_siswa">{jumlahSiswaSesuaiMinat} siswa</span>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-lg-6 col-md-6 col-sm-6 col-xs-6 text-center">
                                        <Gap height={20} />
                                        <h4>Berpotensi Pada Bidang Lainnya</h4>
                                        <div className="panel panel-default chart_percentase_potensi_siswa">
                                            <div className="panel-body easypiechart-panel">
                                                <div className="easypiechart chart" id="easypiechart-teal" data-percent={persenSiswaPindahBidang}>
                                                    <div className="label_persentase_potensi_chart">
                                                        <span className="persentase_potensi">{persenSiswaPindahBidang}%</span>
                                                        <br />
                                                        <span className="jumlah_siswa">{jumlahSiswaPindahBidang} siswa</span>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <Gap height={40} />
                {/* <div className="reportFooter">
                    <FooterReport color={"#1D3557"} date={dateTime} />
                </div> */}
            </div>

            {openPage ? (
                <PageTwo
                    idJadwalCbt={idJadwalCbt}
                    idKelas={idKelas}
                    kodeTahunAjaran={kodeTahunAjaran}
                    schoolName={detailSekolah.namaSekolah}
                    kuotaPariwisata={kuotaPariwisata}
                    kuotaBisnisDanManajemen={kuotaBisnisDanManajemen}
                    kuotaSeniDanEkonomiKreatif={kuotaSeniDanEkonomiKreatif}
                    kuotaAgribisnisDanAgriteknologi={kuotaAgribisnisDanAgriteknologi}
                    kuotaKemaritiman={kuotaKemaritiman}
                    kuotaKesehatanDanPekerjaanSosial={kuotaKesehatanDanPekerjaanSosial}
                    kuotaTeknologiInformasi={kuotaTeknologiInformasi}
                    kuotaTeknologiManufakturDanRekayasa={kuotaTeknologiManufakturDanRekayasa}
                    kuotaTeknologiKonstruksiDanProperti={kuotaTeknologiKonstruksiDanProperti}
                    kuotaEnergiDanPertambangan={kuotaEnergiDanPertambangan}
                />
            ) : (
                <LoadingPage />
            )}
        </>
    );
};

export default PageOne;
